<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 804.9 975.4"
  >
    <path
      d="M1045.68,1010.57h0c-180.51-297-402.45-306.09-402.45-580.92V119h0c104.46,8.5,402.45-83.79,402.45-83.79"
      transform="translate(-643.23 -35.17)"
      fill="transparent"
    />
    <path
      d="M1045.68,1010.57h0c180.5-297,402.44-306.09,402.44-580.92V119h0c-104.45,8.5-402.44-83.79-402.44-83.79"
      transform="translate(-643.23 -35.17)"
      fill="transparent"
    />
    <path
      d="M1045.68,984C871.55,697.56,657.46,698.76,657.46,433.65V135.5h0C758.23,143.7,1045.68,51,1045.68,51"
      transform="translate(-643.23 -35.17)"
      fill="#FB6107"
    />
    <path
      d="M1045.68,984c174.12-286.47,388.21-285.27,388.21-550.38V135.5h0C1333.13,143.7,1045.68,51,1045.68,51"
      transform="translate(-643.23 -35.17)"
      fill="#DA5000"
    />
    <path
      d="M1397.9,463.13c-9,199.28-178.08,204.51-316.26,431.85V463.13Z"
      transform="translate(-643.23 -35.17)"
      fill="#F7CE5B"
    />
    <path
      d="M692.71,417.16c-.25-5.53-.39-11.2-.39-17V157.25c82.08,6.68,316.23-68.83,316.23-68.83V417.16Z"
      transform="translate(-643.23 -35.17)"
      fill="#FFE070"
    />
  </svg>
</template>

<script>
export default {
  name: "ShieldIcon"
};
</script>
